import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../page-header/PageHeader";
import StickySaveBar from "./components/StickySaveBar";
import CompOffPolicyForm from "./CompOffPolicyForm";
import {
	saveDraft,
	publishPolicy,
	clonePolicy,
	resetPolicy,
	loadCompOffForLeavePolicy,
} from "../../redux/rtk/features/compOffPolicy/compOffPolicySlice";
import { validatePolicy } from "./utils/policyUtils";
import "./compOffPolicy.css";
import { useEffect } from "react";

export default function CompOffPolicySettings() {
	const dispatch = useDispatch();
	const { policy, lastSaved } = useSelector((state) => state.compOffPolicy);

	const validation = useMemo(() => validatePolicy(policy), [policy]);

	useEffect(() => {
		dispatch(loadCompOffForLeavePolicy(null));
	}, [dispatch]);

	return (
		<div className="compoff-policy-page">
			<PageTitle
				title="Comp-Off / Combo-Off Policy Settings"
				subtitle="Configure compensatory off policies without code changes"
			/>

			<CompOffPolicyForm embedded={false} />

			<StickySaveBar
				status={policy.general?.status}
				lastSaved={lastSaved}
				hasErrors={validation.errors?.length > 0}
				onSaveDraft={() => dispatch(saveDraft())}
				onPublish={() => dispatch(publishPolicy())}
				onClone={() => dispatch(clonePolicy())}
				onReset={() => dispatch(resetPolicy())}
			/>
		</div>
	);
}
